<template>
  <v-row justify="center" align="center">
    <v-col cols="12">
      <v-banner icon="shopping_cart">
        Basket Selection
        <template v-slot:actions>
          <v-btn outlined color="success" exact @click="createNewTemplate()">
            <v-icon left>add_circle_outline</v-icon>Create Basket
          </v-btn>
          <v-btn text color="blue darken-2" exact @click="$router.go(-1)">
            <v-icon left>arrow_back</v-icon>Back
          </v-btn>
        </template>
      </v-banner>
    </v-col>
    <v-col cols="12">
      <v-row justify="start" align="start" no-gutters>
        <v-col v-if="loadingTrollys" cols="12" lg="12" xs="12">
          <v-card class="mx-auto" outlined height="100%" loading>
            <v-card-title>Loading Baskets...</v-card-title>
            <template slot="progress">
              <v-progress-linear
                color="blue darken-2"
                indeterminate
              ></v-progress-linear>
            </template>
          </v-card>
        </v-col>
        <v-col v-else cols="12" lg="12" xs="12">
          <v-card
            class="mb-4"
            outlined
            v-for="trolly in trollys"
            :key="trolly.id"
            @click="setSelected(trolly.id)"
            :class="`${
              $store.getters.retrieveSelectedTrolly == trolly.id
                ? 'selected_card'
                : ''
            }`"
          >
            <v-card-title>
              {{ DelColLabel }} Date:
              {{ convertDateToDisplay(trolly.order_date) }}
              <v-chip
                v-if="$store.getters.retrieveSelectedTrolly == trolly.id"
                class="ma-2"
                color="success"
                label
                outlined
              >
                <v-icon left>shopping_cart</v-icon>Current Basket
              </v-chip>
            </v-card-title>
            <v-card-text>
              Reference:
              <b>{{ trolly.cust_ref }}</b>
            </v-card-text>
            <v-card-subtitle class="pt-0">
              Basket ID:
              <b>{{ trolly.id }}</b>
            </v-card-subtitle>
            <!-- <v-card-actions>
              <v-btn text color="error">Delete</v-btn>
              <v-spacer />
              <v-btn text color="blue darken-2">Select</v-btn>
            </v-card-actions>-->
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      loadingTrollys: false,
    };
  },

  computed: {
    trollys() {
      return this.$store.getters.retrieveAllTrollys;
    },

    DelColLabel() {
      let label = "Delivery";

      if (this.$store.getters.retrieveIsCncCustomer) {
        label = "Collection ";
      }

      return label;
    },
  },

  methods: {
    ...mapActions(["getTrollys", "setSnackbar", "setSelectedTrolly"]),

    setSelected(id) {
      this.setSelectedTrolly(id);
      this.$router.go(-1);
    },

    convertDateToDisplay(date) {
      return moment(date).format("dddd, Do MMMM YYYY");
    },

    createNewTemplate() {
      this.setSelectedTrolly(0);
      this.$router.push({ name: "OrdersCreate" });
    },
  },
};
</script>

<style lang="sass" scoped>
*
  word-break: break-word

.selected_card
  color: var(--v-color-base) !important
  background-color: var(--v-background-base) !important
  border-color: var(--v-success-base) !important
</style>